"use strict";
'use es6'; // phasing this one out in favor of the one below

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAYLIST_CONFIG_KEY = exports.PLAYLIST_QUERY_LOCAL_STORAGE_KEY = void 0;
var PLAYLIST_QUERY_LOCAL_STORAGE_KEY = 'TaskPlaylistQuery'; // the new key for task playlists

exports.PLAYLIST_QUERY_LOCAL_STORAGE_KEY = PLAYLIST_QUERY_LOCAL_STORAGE_KEY;
var PLAYLIST_CONFIG_KEY = 'TaskPlaylistConfig';
exports.PLAYLIST_CONFIG_KEY = PLAYLIST_CONFIG_KEY;